export default __webpack_public_path__ + "static/media/full_arrow_top.15564ffb.svg";